<template>
    <v-app fluid>
        <transition name="fade">
            <app-overlay />
        </transition>
        <app-container>
            <template slot="main">
                <vue-page-transition :name="transitionPage">
                    <router-view />
                </vue-page-transition>
            </template>
        </app-container>
        <app-menu />
    </v-app>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'App',
        components: {
            AppMenu: () => import('./components/AppMenu'),
            AppOverlay: () => import('./components/AppOverlay'),
            AppContainer: () => import('./components/AppContainer')
        },
        computed: {
            ...mapGetters('experiences', ['experiences']),
            ...mapGetters('app', ['isPro', 'transitionPage', 'isMobile', 'windowSize'])
        },
        created () {
            this.getProfil().catch((err) => {
                this.$toasted.show(err);
            });
            this.refreshQuotas().catch((err) => {
                this.$toasted.show(err);
            });
        },
        mounted () {
            let _this = this;
            let resizeTimer;
            window.addEventListener('resize', function () {
                _this.refreshWindowSize(_this.$vuetify.breakpoint.name);
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    _this.refreshWindowSize(_this.$vuetify.breakpoint.name);
                }, 250);
            });
            this.refreshWindowSize(this.$vuetify.breakpoint.name);
        },
        methods: {
            ...mapActions('app', ['getProfil', 'refreshQuotas', 'refreshWindowSize'])
        }
    };
</script>

<style>
    html, body {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow-y: auto !important;
    }

    body, #app {
        margin: 0 !important;
        padding: 0 !important;
        font-family: 'Fira Sans', sans-serif;
        background-color: #F1F1F1;
        width: 100vw;
        height: 100vh;
    }

    #app .application--wrap {
        z-index: 1;
        overflow: hidden;
    }

    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .v-application--wrap {
        overflow: hidden;
    }

    .toasted.bubble.success {
        background: #169CEB !important;
    }

    .app_content {
        position: absolute;
        right: 0;
        width: 100%;
    }

    .custom_btn_color_blue {
        background-color: #169CEB !important;
        transition: background-color 0.1s ease-in;
    }

    .custom_btn_color_blue:before, .custom_btn_color_blue:focus:before, .custom_btn_color_blue:hover:before {
        background-color: #1976d2 !important;
        transition: background-color 0.1s ease-in;
    }

    .custom_btn_position {
        top: 50%;
        transform: translateY(-50%);
        width: 100% !important;
        min-width: 100% !important;
        color: white !important;
        font-weight: 600 !important;
        text-transform: initial !important;
    }

    .custom_btn_color_red {
        background-color: rgba(255, 10, 0, 0.8) !important;
        transition: background-color 0.1s ease-in;
    }

    .custom_btn_color_red:before, .custom_btn_color_red:focus:before, .custom_btn_color_red:hover:before {
        background-color: red !important;
        transition: background-color 0.1s ease-in;
    }

    .custom_btn_position .v-btn__content span {
        margin-left: 10px !important;
    }

    .v-btn {
        min-width: 40px;
    }

    .v-menu__content {
        z-index: 41 !important;
    }

    .columns {
        margin: 0;
    }

    .is-fluid {
        margin-left: 4% !important;
        margin-right: 4% !important;
    }

    // TRANSITION FADE
    .fade-enter-active, .fade-leave-active {
        opacity: 1;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
        -webkit-transition: all 0.3s ease;
        -moz-transition: all 0.3s ease;
        transition: all 0.3s ease;
    }
</style>
